import {URL} from './api';
import axios from 'axios';

export const HELPBAR_SUCCESS = 'HELPBAR_SUCCESS';
export const HELPBAR_RESET = 'HELPBAR_RESET';

export function helpBarReset(){
    return {
        type: HELPBAR_RESET
    }
}

export function helpBarAction(data){           
    
    return {
        type: HELPBAR_SUCCESS,
        data
    }
};    


// WEBPACK FOOTER //
// ./src/actions/helpbarAction.js